// ** React Imports
import { memo } from "react";

// ** Third Party Components
import loadable from "@loadable/component";

// ** Custom Components
import Block from "components/layout/Block";
const LocationChips = loadable(() => import("components/other/LocationChips"));
const PreferencesChips = loadable(() =>
	import("components/other/PreferencesChips")
);

// #####################################################

const Breadcrumbs = ({
	locationPath,
	preferenceUrl,
	preferenceQueryUrl,
	locationChipsVisible,
	queryAsString,
	countryUrl,
	regionUrl,
	cityUrl,
	withOtherCities,
}) => {
	// #####################################################

	return (
		<Block>
			{locationChipsVisible && (
				<LocationChips
					locationPath={locationPath}
					queryAsString={queryAsString}
					countryUrl={countryUrl}
					regionUrl={regionUrl}
					cityUrl={cityUrl}
					withOtherCities={withOtherCities}
				/>
			)}
			{(preferenceQueryUrl || preferenceUrl) && (
				<PreferencesChips
					locationChipsVisible={locationChipsVisible}
					locationPath={locationPath}
					preferenceUrl={preferenceUrl}
				/>
			)}
		</Block>
	);
};

// #####################################################

export default memo(Breadcrumbs);

// #####################################################
